/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AnswerWrongIcon = /*#__PURE__*/ createSvgIcon(
  'AnswerWrongIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 11.063l2.417 2.416c.152.153.33.226.53.219a.769.769 0 00.532-.24.729.729 0 000-1.061L11.063 9.99l2.416-2.408a.727.727 0 000-1.061.73.73 0 00-1.062 0L10 8.938 7.583 6.52a.718.718 0 00-.52-.23.718.718 0 00-.521.23.729.729 0 00-.002 1.062L8.937 10l-2.416 2.417a.681.681 0 00-.219.52.758.758 0 00.24.521.729.729 0 001.06.002L10 11.062zM10.006 18a7.81 7.81 0 01-3.11-.625 8.064 8.064 0 01-2.552-1.719 8.065 8.065 0 01-1.719-2.551A7.819 7.819 0 012 9.99c0-1.104.208-2.14.625-3.105a8.066 8.066 0 014.27-4.26A7.819 7.819 0 0110.01 2a7.75 7.75 0 013.105.625 8.082 8.082 0 014.26 4.265A7.77 7.77 0 0118 9.994a7.81 7.81 0 01-.625 3.11 8.063 8.063 0 01-1.719 2.552 8.081 8.081 0 01-2.546 1.719 7.77 7.77 0 01-3.104.625zM10 16.5c1.806 0 3.34-.632 4.604-1.896C15.868 13.34 16.5 11.806 16.5 10s-.632-3.34-1.896-4.604C13.34 4.132 11.806 3.5 10 3.5s-3.34.632-4.604 1.896C4.132 6.66 3.5 8.194 3.5 10s.632 3.34 1.896 4.604C6.66 15.868 8.194 16.5 10 16.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AnswerWrongIcon;
